// @ts-ignore
import { routeTo } from 'redux-router-kit';
import {
  getParams,
  getQueryParams,
  getCurrentPathname,
  getCurrentHref,
} from '@zapier/toolbox-redux-framework/src/utils/router-selectors';
import { useRedux } from '../useRedux';
import { Dispatch } from 'redux';

type RouteToOptions = {
  event?: string;
  exit?: string;
  replace?: Boolean;
};

const mapStateToProps = (state: any) => ({
  href: getCurrentHref(state),
  params: getParams(state),
  pathname: getCurrentPathname(state),
  query: getQueryParams(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchRouteTo(href: string, options?: RouteToOptions) {
    return dispatch(routeTo(href, options));
  },
});

type HookReturnValue = {
  href: string;
  params: { [key: string]: string };
  pathname: string;
  query: { [key: string]: string };
  routeTo(href: string, options?: RouteToOptions): void;
};

export default function useRouter(): HookReturnValue {
  const { dispatchRouteTo, href, params, pathname, query } = useRedux(
    mapStateToProps,
    mapDispatchToProps
  );
  return {
    href,
    params,
    pathname,
    query,
    routeTo: dispatchRouteTo,
  };
}
